export default { sha: '398b5f5ad3bbee2c298fed9e076007a2e387f375', buildNumber: 'undefined' }
